// Source - https://github.com/Joe12387/detectIncognito/blob/main/src/detectIncognito.ts
export const isSafariPrivateMode = async () => {
    return new Promise(resolve => {
        try {
            const tmp_name = String(Math.random());
            const db = window.indexedDB.open(tmp_name, 1);

            db.onupgradeneeded = function (i) {
                const res = i.target?.result;

                try {
                    res.createObjectStore("test", {
                        autoIncrement: true,
                    }).put(new Blob);

                    resolve(false);
                } catch (e) {
                    let message = e;

                    if (e instanceof Error) {
                        message = e.message ?? e;
                    }

                    if (typeof message !== 'string') {
                        return resolve(false);
                    }

                    const matchesExpectedError = /BlobURLs are not yet supported/.test(message);

                    return resolve(matchesExpectedError);
                } finally {
                    res.close();
                    window.indexedDB.deleteDatabase(tmp_name);
                }
            }
        } catch (e) {
            return resolve(false);
        }
    })
}
